if ( document.querySelector("[data-password-toggle]") ) {
    document.querySelectorAll("[data-password-toggle]").forEach(button => button.addEventListener("click", () => togglePassword(button)));
  
    // Handle the toggle functionality
    function togglePassword(button) {
      // Prepare References
      const passwordWrapper = button.closest("[data-password]");
      const passwordInput = passwordWrapper.querySelector("input");
  
      // Check what to do based on state of input
      if ( passwordInput.getAttribute("type") === "password" ) {
        passwordInput.setAttribute("type", "text");
      } else {
        passwordInput.setAttribute('type', 'password');
      }
  
      // Update the icon
      passwordWrapper.querySelectorAll('.icon').forEach(icon => icon.classList.toggle('hidden'));
    }
  }